import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from './lib/theme.jsx'
import App from './App.jsx'
import './index.css'

// Silence ad-hoc console.log / console.debug / console.info across the app
// unless VITE_ENABLE_DEBUG_LOGGING=true. Warnings and errors are preserved.
// Flip the flag in frontend/.env when you need the chatter back.
if (import.meta.env.VITE_ENABLE_DEBUG_LOGGING !== 'true') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false, // Prevent automatic refetches on window focus
      refetchOnReconnect: false, // Prevent automatic refetches on reconnect
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
